module.exports = __webpack_public_path__ + "static/media/logo2.88509064.png";